<template>
  <div>
   <div class="box_mode content_wrapper">
      <br>
      <br>
      <br>
      <br>
      <section id="territorios">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-2"></div>
					<div class="col-md-8">
						<h2 class="text-center">Textos Legales e Información</h2>
						<p class="text-center"></p>
					</div>
					<div class="col-md-2"></div>
				</div>
			</div>
			<hr>
		</section><br><br>
		<section id="territorio" class="bg-celeste"><hr>
			<div class="container" v-if="textos && textos.length">
				<div class="cardsLeg" v-for="(texto, i) of textos" v-bind:key="texto + '' + texto.TITULO">
					<div :class="texto.TITULO + ' text-center' ">
						<div class="cardsLeg">
							<div class="cardsLeg-header">
								{{ texto.TITULO }}
							</div>
							<div class="cardsLeg-body">
								<p class="cardsLeg-text">
									<img v-on:click="Descarga(texto.TEXTO, i, tipfile[i], i)" style="height:200px; width:190px;cursor: pointer;" v-if="tipfile[i] == 'pdf'" src="@/assets/img/pdf.png">
									<img v-on:click="Descarga(texto.TEXTO, i, tipfile[i], i)" style="height:200px; width:190px;cursor: pointer;" v-else-if="tipfile[i] == 'doc' || tipfile[i] == 'docx'" src="@/assets/img/documento.png">
									<img v-on:click="Descarga(texto.TEXTO, i, tipfile[i], i)" style="height:200px; width:190px;cursor: pointer;" v-else-if="tipfile[i] == 'xls' || tipfile[i] == 'xlsx'" src="@/assets/img/xls.png">
									<img v-on:click="Descarga(texto.TEXTO, i, tipfile[i], i)" style="height:200px; width:190px;cursor: pointer;" v-else-if="tipfile[i] == 'ppt' || tipfile[i] == 'pptx'" src="@/assets/img/powerpoint.png">
									<img v-on:click="Descarga(texto.TEXTO, i, tipfile[i], i)" style="height:200px; width:190px;cursor: pointer;" v-else-if="tipfile[i] == 'zip' || tipfile[i] == 'rar'" src="@/assets/img/codigo-postal.png">
									<img v-on:click="Descarga(texto.TEXTO, i, tipfile[i], i)" style="height:200px; width:190px;cursor: pointer;" v-else src="@/assets/img/otros.png">
								</p>
								<div class="clearfix"></div>
								<div class="text-center">
									<button v-if="loadingTex[i]" class="btn btn-naranjo-download-leg" v-on:click="Descarga(texto.TEXTO, i, tipfile[i], i)">Descargar</button>
									<button v-if="!loadingTex[i]" class="btn btn-naranjo-leg" v-on:click="Descarga(texto.TEXTO, i, tipfile[i], i)">Descargar</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			<hr>
			</div>
		</section>
	</div>
  </div>
</template>
<script>

import {
  mapState,
  mapActions,
} from 'vuex';
export default {
  methods: {
    ...mapActions([
      'actjuzgados',
      'actcortes',
    ]),
    Descarga: function(archivo, pos, tipo, lug) {
      if (tipo == 'doc' || tipo == 'docx') {
        tipo = 'msword';
      }
      if (tipo == 'xls' || tipo == 'xlsx') {
        tipo = 'vnd.ms-excel';
      }
      if (tipo == 'ppt' || tipo == 'pptx') {
        tipo = 'vnd.ms-powerpoint';
      }
      if (tipo == 'rar') {
        tipo = 'x-rar-compressed';
      }
      this.$set(this.loadingTex, pos, true);
      console.log(this.ipact + '/descargas/' + archivo);
      this.axios.get(this.ipact + '/descargas/' + archivo, {responseType: 'blob'})
          .then(({data}) => {
            const blob = new Blob([data], {type: 'application/' + tipo});
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = archivo;
            link.click();
            this.$set(this.loadingTex, pos, false);
          })
          .catch(function(error) {

          });
    },
  },
  mounted() {
    this.axios.get(this.ipapi + 'textos/legales/0/0')
        .then((response) => {
          this.textos = response.data;
          for (let i = 0; i < this.textos.length; i++) {
            console.log(this.textos[i].TEXTO);
            this.loadingTex[i] = false;
            const res = this.textos[i].TEXTO.split('.');
            this.tipfile[i] = res[1];
          }
        })
        .catch(function(error) {

        });
  },
  components: { },
  data() {
    return {
      ubicacion: 0,
      textos: [],
      tipfile: [],
      loadingTex: [],
    };
  },
  computed: {
    ...mapState([
      'juzgados',
      'cortes',
      'ipapi',
      'ipact',
    ]),
  },
};
</script>
<style src="vue-slim-tabs/themes/default.css"></style>
<style>
/*cardsLegss*/
.cardsLeg{position:relative;display:-ms-flexbox;display:inline-flex;-ms-flex-direction:column;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip: border-box;
    border: 0px solid rgba(0,0,0,.125);
    border-radius: .85rem; margin-bottom: 10px}
.cardsLeg>hr{margin-right:0;margin-left:0}
.cardsLeg>.list-group:first-child .list-group-item:first-child{border-top-left-radius:.85rem;border-top-right-radius:.85rem}
.cardsLeg>.list-group:last-child .list-group-item:last-child{border-bottom-right-radius:.85rem;border-bottom-left-radius:.85rem}
.cardsLeg-body{-ms-flex:1 1 auto;flex:1 1 auto;padding:1.25rem}
.cardsLeg-title{margin-bottom:.75rem}
.cardsLeg-subtitle{margin-top:-.375rem;margin-bottom:0}
.cardsLeg-text:last-child{margin-bottom:0}
.cardsLeg-link:hover{text-decoration:none}
.cardsLeg-link+.cardsLeg-link{margin-left:1.25rem}
.cardsLeg-header{padding:.75rem 1.25rem;margin-bottom:0;background-color:#3c4c9b;border-bottom:1px solid rgba(0,0,0,.125); color: #fff;}
.cardsLeg-header:first-child{border-radius:calc(.85rem - 1px) calc(.85rem - 1px) 0 0}
.cardsLeg-header+.list-group .list-group-item:first-child{border-top:0}
.cardsLeg-footer{padding:.75rem 1.25rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.cardsLeg-footer:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.cardsLeg-header-tabs{margin-right:-.625rem;margin-bottom:-.75rem;margin-left:-.625rem;border-bottom:0}.cardsLeg-header-pills{margin-right:-.625rem;margin-left:-.625rem}.cardsLeg-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem}.cardsLeg-img{width:100%;border-radius:calc(.25rem - 1px)}.cardsLeg-img-top{width:100%;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.cardsLeg-img-bottom{width:100%;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.cardsLeg-deck{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.cardsLeg-deck .cardsLeg{margin-bottom:15px}@media (min-width:576px){.cardsLeg-deck{-ms-flex-flow:row wrap;flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.cardsLeg-deck .cardsLeg{display:-ms-flexbox;display:flex;-ms-flex:1 0 0%;flex:1 0 0%;-ms-flex-direction:column;flex-direction:column;margin-right:15px;margin-bottom:0;margin-left:15px}}.cardsLeg-group{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.cardsLeg-group>.cardsLeg{margin-bottom:15px}@media (min-width:576px){.cardsLeg-group{-ms-flex-flow:row wrap;flex-flow:row wrap}.cardsLeg-group>.cardsLeg{-ms-flex:1 0 0%;flex:1 0 0%;margin-bottom:0}.cardsLeg-group>.cardsLeg+.cardsLeg{margin-left:0;border-left:0}.cardsLeg-group>.cardsLeg:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.cardsLeg-group>.cardsLeg:first-child .cardsLeg-header,.cardsLeg-group>.cardsLeg:first-child .cardsLeg-img-top{border-top-right-radius:0}.cardsLeg-group>.cardsLeg:first-child .cardsLeg-footer,.cardsLeg-group>.cardsLeg:first-child .cardsLeg-img-bottom{border-bottom-right-radius:0}.cardsLeg-group>.cardsLeg:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.cardsLeg-group>.cardsLeg:last-child .cardsLeg-header,.cardsLeg-group>.cardsLeg:last-child .cardsLeg-img-top{border-top-left-radius:0}.cardsLeg-group>.cardsLeg:last-child .cardsLeg-footer,.cardsLeg-group>.cardsLeg:last-child .cardsLeg-img-bottom{border-bottom-left-radius:0}.cardsLeg-group>.cardsLeg:only-child{border-radius:.25rem}.cardsLeg-group>.cardsLeg:only-child .cardsLeg-header,.cardsLeg-group>.cardsLeg:only-child .cardsLeg-img-top{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.cardsLeg-group>.cardsLeg:only-child .cardsLeg-footer,.cardsLeg-group>.cardsLeg:only-child .cardsLeg-img-bottom{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.cardsLeg-group>.cardsLeg:not(:first-child):not(:last-child):not(:only-child){border-radius:0}.cardsLeg-group>.cardsLeg:not(:first-child):not(:last-child):not(:only-child) .cardsLeg-footer,.cardsLeg-group>.cardsLeg:not(:first-child):not(:last-child):not(:only-child) .cardsLeg-header,.cardsLeg-group>.cardsLeg:not(:first-child):not(:last-child):not(:only-child) .cardsLeg-img-bottom,.cardsLeg-group>.cardsLeg:not(:first-child):not(:last-child):not(:only-child) .cardsLeg-img-top{border-radius:0}}.cardsLeg-columns .cardsLeg{margin-bottom:.75rem}@media (min-width:576px){.cardsLeg-columns{-webkit-column-count:3;-moz-column-count:3;column-count:3;-webkit-column-gap:1.25rem;-moz-column-gap:1.25rem;column-gap:1.25rem;orphans:1;widows:1}.cardsLeg-columns .cardsLeg{display:inline-block;width:100%}}.accordion .cardsLeg:not(:first-of-type):not(:last-of-type){border-bottom:0;border-radius:0}.accordion .cardsLeg:not(:first-of-type) .cardsLeg-header:first-child{border-radius:0}.accordion .cardsLeg:first-of-type{border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.accordion .cardsLeg:last-of-type{border-top-left-radius:0;border-top-right-radius:0}
.cardsLeg select{
	display: inline-block;
	border: 2px solid #3f51b5;
    background-color: #fff;
    color: #666;
    border-radius: 19px;
    padding: 10px 10px;
    height: 38px;
	position: relative;
	float: right;
}</style>
